<script setup>
import { onMounted, ref, inject } from 'vue';
import { formatDate } from '../helpers';
import ModalForm from './elements/ModalForm.vue';
import PromptSnippetImportExport from './promptSnippets/PromptSnippetImportExport.vue';
import axios from 'axios';

const env = inject('env', {
    currentSubscription: null,
    sectorOptions: '{}',
    categories: '{}',
    configCategoryOptions: '{}',
    configCategoryLabels: '{}',
    activeSubscription: null,
    activeSector: null
});

onMounted(() => {
    // reset errors and current snippet when modals are closed
    $('#' + updateFormId).on('hidden.bs.modal', function () {
        updateErrors.value = {};
        currentPromptSnippet.value = {
            ...defaultPromptSnippetValues
        };
    });
    $('#' + addFormId).on('hidden.bs.modal', function () {
        addErrors.value = {};
        defaultPromptSnippet.value = {
            ...defaultPromptSnippetValues
        };
    });

    loadSubscriptions();
    getEntries();
});

const emit = defineEmits(['beforeLoadingEntries', 'afterLoadingEntries']);

const addFormId = "prompt-snippet-add-modal";
const updateFormId = "prompt-snippet-edit-modal";
const deleteFormId = "prompt-snippet-delete-modal";
const defaultPromptSnippetValues = {
    id: 0,
    category: '',
    config_category: '',
    sector: '',
    title: '',
    text: '',
    subscription_id: null
};
let promptSnippets = ref([]);
let currentPromptSnippet = ref({
    ...defaultPromptSnippetValues
});
let loading = ref(0);
let addErrors = ref({});
let updateErrors = ref({});

let subscriptionFilter = ref('__null');
let sectorFilter = ref(env.activeSector || '');
let subscriptionList = ref({});
let categories = ref({});
let sectorOptions = ref({});
let configCategoryOptions = ref({});
let configCategoryLabels = ref({});

try {
    if (env.categories) {
        categories.value = typeof env.categories === 'string' ? JSON.parse(env.categories) : env.categories;
    }
    if (env.sectorOptions) {
        sectorOptions.value = typeof env.sectorOptions === 'string' ? JSON.parse(env.sectorOptions) : env.sectorOptions;
    }
    if (env.configCategoryOptions) {
        configCategoryOptions.value = typeof env.configCategoryOptions === 'string'
            ? JSON.parse(env.configCategoryOptions)
            : env.configCategoryOptions;
    }
    if (env.configCategoryLabels) {
        configCategoryLabels.value = typeof env.configCategoryLabels === 'string'
            ? JSON.parse(env.configCategoryLabels)
            : env.configCategoryLabels;
    }
} catch (e) {
    console.error('Error parsing env data in PromptSnippetIndex', e);
}

function getConfigOptionsFor(category) {
    if (!category || !configCategoryOptions.value[category]) {
        return [];
    }
    return configCategoryOptions.value[category].map((val) => ({
        value: val,
        label: configCategoryLabels.value[val] || val,
    }));
}

function loadSubscriptions() {
    loading.value++;
    axios.get('/ajax/subscriptions', {})
        .then((response) => {
            subscriptionList.value = {};
            for (let i = 0; i < response.data.length; i++) {
                subscriptionList.value[response.data[i].id] = response.data[i].name;
            }
            loading.value--;
        })
        .catch(function () {
            loading.value--;
        });
}

function showAddForm() {
    // reset to defaults and preselect subscription from filter if applicable
    currentPromptSnippet.value = {
        ...defaultPromptSnippetValues
    };
    if (subscriptionFilter.value && subscriptionFilter.value !== '__null') {
        currentPromptSnippet.value.subscription_id = subscriptionFilter.value;
    }
    $('#' + addFormId).modal();
}

function onListAction(action, data) {
    if (action == 'edit') {
        currentPromptSnippet.value = data;
        $('#' + updateFormId).modal();
    } else if (action == 'delete') {
        currentPromptSnippet.value = data;
        $('#' + deleteFormId).modal();
    }
}

function onCreateFormSubmit(submitEvent) {
    const formData = new FormData(submitEvent.target);
    loading.value++;
    axios.post('/ajax/promptSnippets', formData, {
    })
        .then((res) => {
            loading.value--;
            $('#' + addFormId).modal('hide');
            getEntries();
        })
        .catch(function (error) {
            loading.value--;
            if (error.response && error.response.data && error.response.data.errors) {
                addErrors.value = error.response.data.errors;
            }
            console.error(error);
        });
}

function onUpdateFormSubmit(submitEvent) {
    const formData = new FormData(submitEvent.target);
    formData.append("_method", 'PATCH');
    loading.value++;
    axios.post('/ajax/promptSnippets/' + formData.get('id'), formData, {
    })
        .then((res) => {
            loading.value--;
            $('#' + updateFormId).modal('hide');
            getEntries();
        })
        .catch(function (error) {
            loading.value--;
            if (error.response && error.response.data && error.response.data.errors) {
                updateErrors.value = error.response.data.errors;
            }
            console.error(error);
        });
}

function onDeleteFormSubmit() {
    loading.value++;
    axios.delete('/ajax/promptSnippets/' + currentPromptSnippet.value.id)
        .then((res) => {
            loading.value--;
            $('#' + deleteFormId).modal('hide');
            getEntries();
        })
        .catch(function (error) {
            loading.value--;
            console.error(error);
        });
}

function changeFilters() {
    getEntries();
}

function getEntries() {
    emit('beforeLoadingEntries');
    loading.value++;
    const params = {
        // we always load all snippets, but still support filtering on the backend
    };
    if (subscriptionFilter.value && subscriptionFilter.value !== '__null') {
        params.subscription_id = subscriptionFilter.value;
    }
    if (sectorFilter.value) {
        params.sector = sectorFilter.value;
    }

    axios.get('/ajax/promptSnippets', { params })
        .then((response) => {
            let data = response.data;
            if (subscriptionFilter.value === '__null') {
                data = data.filter((s) => !s.subscription_id);
            }
            promptSnippets.value = data;
            emit('afterLoadingEntries', true);
            loading.value--;
        })
        .catch(function (error) {
            emit('afterLoadingEntries', false);
            loading.value--;
            console.error(error);
        });
}
</script>

<template>
    <div class="row">
        <div class="col-4">
            <div class="input-group mb-3">
                <label>
                    Branche
                    <select class="form-control" name="sector" v-model="sectorFilter" @change="changeFilters">
                        <option value>alle Branchen</option>
                        <option v-for="(label, key) in sectorOptions" :value="key">
                            {{ label }}
                        </option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-4">
            <div class="input-group mb-3">
                <label>
                    Mandant
                    <select class="form-control" name="subscription_id" v-model="subscriptionFilter"
                        @change="changeFilters">
                        <option value="__null">kein Mandant</option>
                        <option value="">alle</option>
                        <option v-for="(subscriptionName, index) in subscriptionList" :value="index">
                            {{ subscriptionName }}
                        </option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-4 text-right align-self-end mb-4">
            <div class="mb-2">
                <PromptSnippetImportExport :subscription-filter="subscriptionFilter" :sector-filter="sectorFilter"
                    :subscription-list="subscriptionList" @imported="getEntries" />
            </div>
            <button class="btn btn-primary" type="button" @click.prevent="showAddForm">Option hinzufügen</button>
        </div>
    </div>
    <ModalForm :modal-id="addFormId" modal-title="Option hinzufügen" modal-class="modal-lg" submit-text="speichern"
        dismiss-text="abbrechen" :loading="loading" @form-submit="onCreateFormSubmit">
        <div class="form-group">
            <label>Kategorie</label>
            <select class="form-control" name="category" v-model="currentPromptSnippet.category">
                <option value=""></option>
                <option v-for="(label, key) in categories" :value="key">
                    {{ label }}
                </option>
            </select>
            <div class="invalid-feedback d-block" v-if="addErrors.category">
                {{ addErrors.category[0] }}
            </div>
        </div>
        <div class="form-group" v-if="getConfigOptionsFor(currentPromptSnippet.category).length">
            <label>Konfigurationskategorie</label>
            <select class="form-control" name="config_category">
                <option value=""></option>
                <option v-for="opt in getConfigOptionsFor(currentPromptSnippet.category)" :key="opt.value"
                    :value="opt.value">
                    {{ opt.label }}
                </option>
            </select>
            <div class="invalid-feedback d-block" v-if="addErrors.config_category">
                {{ addErrors.config_category[0] }}
            </div>
        </div>
        <div class="form-group">
            <label>Branche</label>
            <select class="form-control" name="sector">
                <option value=""></option>
                <option v-for="(label, key) in sectorOptions" :value="key">
                    {{ label }}
                </option>
            </select>
            <div class="invalid-feedback d-block" v-if="addErrors.sector">
                {{ addErrors.sector[0] }}
            </div>
        </div>
        <div class="form-group">
            <label>Mandant</label>
            <select class="form-control" name="subscription_id" v-model="currentPromptSnippet.subscription_id">
                <option value=""></option>
                <option v-for="(subscriptionName, index) in subscriptionList" :value="index">
                    {{ subscriptionName }}
                </option>
            </select>
            <div class="invalid-feedback d-block" v-if="addErrors.subscription_id">
                {{ addErrors.subscription_id[0] }}
            </div>
        </div>
        <div class="form-group">
            <label>Titel</label>
            <input type="text" class="form-control" name="title" />
            <div class="invalid-feedback d-block" v-if="addErrors.title">
                {{ addErrors.title[0] }}
            </div>
        </div>
        <div class="form-group">
            <label>Text</label>
            <textarea class="form-control" name="text" rows="4"></textarea>
            <div class="invalid-feedback d-block" v-if="addErrors.text">
                {{ addErrors.text[0] }}
            </div>
        </div>
    </ModalForm>

    <div v-for="(categoryLabel, catKey) in categories" :key="catKey" class="mt-4">
        <h4>{{ categoryLabel }}</h4>
        <ul class="list-group mb-3">
            <li v-for="snippet in promptSnippets.filter(s => s.category === catKey)" :key="snippet.id"
                class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                    <strong>{{ snippet.title }}</strong>
                    <span v-if="snippet.subscription_id && subscriptionList[snippet.subscription_id]"
                        class="text-muted">
                        - {{ subscriptionList[snippet.subscription_id] }}
                    </span>
                    <span v-if="snippet.sector && sectorOptions[snippet.sector]" class="text-muted">
                        - {{ sectorOptions[snippet.sector] }}
                    </span>
                </div>
                <div>
                    <button class="btn btn-sm ml-1 btn-outline-primary" type="button"
                        @click="onListAction('edit', snippet)">
                        bearbeiten
                    </button>
                    <button class="btn btn-sm ml-1 btn-outline-danger" type="button"
                        @click="onListAction('delete', snippet)">
                        löschen
                    </button>
                </div>
            </li>
            <li v-if="!promptSnippets.some(s => s.category === catKey)" class="list-group-item text-muted">
                Keine Optionen vorhanden.
            </li>
        </ul>
    </div>
    <ModalForm :modal-id="updateFormId" modal-title="Option bearbeiten" modal-class="modal-lg" submit-text="speichern"
        dismiss-text="abbrechen" :loading="loading" @form-submit="onUpdateFormSubmit">
        <input v-if="currentPromptSnippet.id" type="hidden" name="id" v-model="currentPromptSnippet.id" />
        <div class="form-group">
            <label>Kategorie</label>
            <select class="form-control" name="category" v-model="currentPromptSnippet.category">
                <option value=""></option>
                <option v-for="(label, key) in categories" :value="key">
                    {{ label }}
                </option>
            </select>
            <div class="invalid-feedback d-block" v-if="updateErrors.category">
                {{ updateErrors.category[0] }}
            </div>
        </div>
        <div class="form-group" v-if="getConfigOptionsFor(currentPromptSnippet.category).length">
            <label>Konfigurationskategorie</label>
            <select class="form-control" name="config_category" v-model="currentPromptSnippet.config_category">
                <option value=""></option>
                <option v-for="opt in getConfigOptionsFor(currentPromptSnippet.category)" :key="opt.value"
                    :value="opt.value">
                    {{ opt.label }}
                </option>
            </select>
            <div class="invalid-feedback d-block" v-if="updateErrors.config_category">
                {{ updateErrors.config_category[0] }}
            </div>
        </div>
        <div class="form-group">
            <label>Branche</label>
            <select class="form-control" name="sector" v-model="currentPromptSnippet.sector">
                <option value=""></option>
                <option v-for="(label, key) in sectorOptions" :value="key">
                    {{ label }}
                </option>
            </select>
            <div class="invalid-feedback d-block" v-if="updateErrors.sector">
                {{ updateErrors.sector[0] }}
            </div>
        </div>
        <div class="form-group">
            <label>Mandant</label>
            <select class="form-control" name="subscription_id" v-model="currentPromptSnippet.subscription_id">
                <option value=""></option>
                <option v-for="(subscriptionName, index) in subscriptionList" :value="index">
                    {{ subscriptionName }}
                </option>
            </select>
            <div class="invalid-feedback d-block" v-if="updateErrors.subscription_id">
                {{ updateErrors.subscription_id[0] }}
            </div>
        </div>
        <div class="form-group">
            <label>Titel</label>
            <input type="text" class="form-control" name="title" v-model="currentPromptSnippet.title" />
            <div class="invalid-feedback d-block" v-if="updateErrors.title">
                {{ updateErrors.title[0] }}
            </div>
        </div>
        <div class="form-group">
            <label>Text</label>
            <textarea class="form-control" name="text" rows="4" v-model="currentPromptSnippet.text"></textarea>
            <div class="invalid-feedback d-block" v-if="updateErrors.text">
                {{ updateErrors.text[0] }}
            </div>
        </div>
    </ModalForm>
    <ModalForm :modal-id="deleteFormId" modal-title="Option Löschen" modal-class="modal-lg" submit-text="ja"
        dismiss-text="nein" :loading="loading" @form-submit="onDeleteFormSubmit">Wollen Sie die Option "{{
            currentPromptSnippet ? currentPromptSnippet.title : '' }}" wirklich löschen?</ModalForm>
</template>